var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("global.search"),
                      "append-icon": "search",
                      "hide-details": "",
                      "single-line": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("v-checkbox", {
                staticClass: "mx-5",
                attrs: {
                  label: _vm.$t(
                    "delegation.form.bookingAndInvoices.showAllBookingTypes"
                  )
                },
                model: {
                  value: _vm.showAll,
                  callback: function($$v) {
                    _vm.showAll = $$v
                  },
                  expression: "showAll"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredBookings,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "items-per-page": 5
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function(props) {
                return [
                  _c("tr", [
                    _c("td", {}, [
                      _vm._v(
                        _vm._s(_vm.formatDateView(props.item.creation_date))
                      )
                    ]),
                    _c(
                      "td",
                      [
                        _vm._v(" " + _vm._s(props.item.name) + " "),
                        props.item.is_cancelled === 1
                          ? _c(
                              "v-chip",
                              {
                                staticStyle: {
                                  color: "#FFE3F3",
                                  "background-color": "#ff99d0 !important"
                                },
                                attrs: { label: "", outlined: "", small: "" }
                              },
                              [_vm._v(_vm._s(_vm.$t("booking.canceled")) + " ")]
                            )
                          : _vm._e(),
                        _c("assigned-delegations-chip", {
                          attrs: { delegations: props.item.delegations }
                        })
                      ],
                      1
                    ),
                    _c("td", [_vm._v(_vm._s(props.item.client_name))]),
                    _c("td", [_vm._v(_vm._s(props.item.client_surname))]),
                    _c("td", [
                      _vm._v(
                        _vm._s(props.item.reservation_number) +
                          " " +
                          _vm._s(props.item.ticket_number)
                      )
                    ]),
                    _c(
                      "td",
                      { staticClass: "datatable-total-amount" },
                      [
                        props.item.invoice_gross_value !== null
                          ? [
                              _vm._v(
                                _vm._s(props.item.invoice_gross_value) +
                                  " " +
                                  _vm._s(props.item.invoice_currency)
                              )
                            ]
                          : props.item.total_amount !== null
                          ? [_vm._v(_vm._s(props.item.total_amount) + " PLN")]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "td",
                      { staticClass: "text-center text-no-wrap" },
                      [
                        _vm._t(
                          "action",
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass: "mx-0",
                                                attrs: {
                                                  disabled:
                                                    _vm.$store.getters[
                                                      "Ajax/loading"
                                                    ],
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.downloadAttachment(
                                                      props.item.id
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [
                                              _c("v-icon", [
                                                _vm._v("cloud_download")
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.downloadFile")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          { booking: props.item }
                        )
                      ],
                      2
                    )
                  ])
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }